import { Http, Response, URLSearchParams } from '@angular/http';
import { NgModule, Injectable } from '@angular/core';
import { CustomerOverview, ReportStyle, NewCustomer, UpdateCustomer, JobSiteType, ReportRetrieveOptions, CountryVM } from '../models/customer.model';
import { Tuple } from '../models/tuple.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Family, GenericIdName, UpdateCustomerVM, DigitalFormDataVM, AddQuestionVM, ComponentTypeList, FormHeaderVM, ImplementLoadVM, CompListVM, GenericIdName_, UnitMeasureDto, FamilyDto } from '../models/digitalForm.model';
import { JobsiteSelectionFilter } from '../../GET_NEW_UI/favourite-dialog/favourite-dialog-modal';
@Injectable()

export class DigitalFormServiceIdentity {


  private readonly GetFamilyListInfo='api/DigitalForm/getFamilyList';
  private readonly GetModelListInfo='api/DigitalForm/getModelListByFamily';
  private readonly GetFormCategoryListInfo='api/DigitalForm/getFormCategoryList';
  private readonly CreateDigitalFormSetup='api/DigitalForm/CreateDigitalForm';
  private readonly UpdateDigitalFormName='api/DigitalForm/UpdateDigitalFormName';
  private readonly ToggleEmailOnCompleteOnDigitalForm='api/DigitalForm/ToggleEmailOnCompleteOnDigitalForm';
  private readonly ToggleStartByInspectoreOnDigitalForm='api/DigitalForm/ToggleStartByInspectorOnDigitalForm';
  private readonly ToggleStartBySupervisorOnDigitalForm='api/DigitalForm/ToggleStartBySupervisorOnDigitalForm';
  private readonly ToggleFECRTypeDigitalForm='api/DigitalForm/ToggleFECRTypeOnDigitalForm';
  private readonly GetFECRInspectionTypesInfo='api/DigitalForm/getFECRFormInspectionTypsList';
  private readonly ToggleUpdateIsMagetic='api/DigitalForm/ToggleIsMagneticQuestion';
  private readonly ToggleUpdateIsActivateLimits='api/DigitalForm/ToggleIsActivateLimitsQuestion';

  
  
  private readonly UpdateFormFECRInspectionType='api/DigitalForm/UpdateFormFECRType';


  private readonly UpdateDigitalFormCategoryId='api/DigitalForm/UpdateDigitalFormCategory';
  private readonly UpdateCustomerForForms='api/DigitalForm/UpdateCustomerForForms';
  private readonly UpdateJobsiteForForms='api/DigitalForm/UpdateJobsiteForForms';

  private readonly GetDigitalFormInfo='api/DigitalForm/GetDigitalFormsAndFormCategoriesDFI';
  private readonly AddSection='api/DigitalForm/AddNewSection';
  private readonly AddQuestion='api/DigitalForm/AddNewQuestion';
  private readonly AddCategory='api/DigitalForm/AddNewCategory';
  private readonly GetQuestionInfo='api/DigitalForm/GetQuestionDetailsById';
  private readonly EditSelectedQuestion='api/DigitalForm/EditSelectedQuestion';
  private readonly ToggleDigitalFormQuestion='api/DigitalForm/ToggleDigitalFormQuestion';
  private readonly OrderDownForQuestions='api/DigitalForm/OrderDownForQuestions';
  private readonly OrderUpForQuestions='api/DigitalForm/OrderUpForQuestions';
  private readonly OrderDownForSection='api/DigitalForm/OrderDownForSection';
  private readonly OrderUpForSection='api/DigitalForm/OrderUpForSection';
  private readonly OrderDownForCategories='api/DigitalForm/OrderDownForCategories';
  private readonly OrderUpForCategories='api/DigitalForm/OrderUpForCategories';
  private readonly UpdateModelsForForms='api/DigitalForm/UpdateModelsForForms';
  private readonly EditCategorySection='api/DigitalForm/EditCategorySection';
  private readonly GetAllImplementTypes='api/DigitalForm/GetAllImplementTypes';
  private readonly GetComponentTypesByImplementTypeId='api/DigitalForm/getComponentTypesByImplementTypeId';
  private readonly GetFormHeaderInfo='api/DigitalForm/GetDigitalFormHeaderDetails';
  private readonly UpdateFormHeaderInfo='api/DigitalForm/UpdateDigitalFormHeaderDetails';
  private readonly ToggleDigitalForCategory='api/DigitalForm/ToggleDigitalFormCategory';
  private readonly GetComponentByComponentTypeIds='api/DigitalForm/getComponentByComponentTypeIds';
  private readonly UpdateImplementTemplateForForms='api/DigitalForm/UpdateImplementTemplateForForms';
  private readonly GetAllImplementTemplates='api/DigitalForm/GetAllImplementTemplates';
  private readonly GetFormLinkedImplementTemplatesTypes='api/DigitalForm/GetFormLinkedImplementTemplatesTypes';

  private readonly GET_JOBSITE_FILTER='api/Favourite/GeJobsiteAvailable';
  private readonly GET_UNIT_MEASURE='api/DigitalForm/GetUnitMeasurement';
  private readonly GET_FILTERED_FAMILY='api/DigitalForm/GetFamilybasedOnCustomerAndJobsite';
  // private readonly DeleteFormQuestion='api/DigitalForm/DeleteSelectedQuestion';
  // private readonly DeleteFormSection='api/DigitalForm/DeleteCategoryAndSection';
  constructor(private _http: HttpClient) { }

public getFamilyListData(): Observable<Family[]> {
  return this._http.get<Family[]>(this.GetFamilyListInfo).pipe(catchError(this.handleError));
}

public GetModelsAvailable(selectedFamily: number[]): Observable<GenericIdName[]> {
  return this._http.post<GenericIdName[]>(this.GetModelListInfo, selectedFamily).pipe(catchError(this.handleError));
}

public UpdateCustomerForForm(model: UpdateCustomerVM): Observable<boolean> {
  return this._http.post<boolean>(this.UpdateCustomerForForms, model).pipe(catchError(this.handleError));
}

public UpdateJobsiteForForm(model: UpdateCustomerVM): Observable<boolean> {
  return this._http.post<boolean>(this.UpdateJobsiteForForms, model).pipe(catchError(this.handleError));
}

public UpdateFormModels(model: UpdateCustomerVM): Observable<boolean> {
  return this._http.post<boolean>(this.UpdateModelsForForms, model).pipe(catchError(this.handleError));
}

public UpdateFormImplementTemplate(model: UpdateCustomerVM): Observable<boolean> {
  return this._http.post<boolean>(this.UpdateImplementTemplateForForms, model).pipe(catchError(this.handleError));
}

public CreateDigitalForm(formCatId: number ): Observable<number> {
const options = {
    params: new HttpParams().set('formCatId', formCatId.toString())
};
return this._http.get<number>(this.CreateDigitalFormSetup, options).pipe(catchError(this.handleError));
}

public UpdateDigitalFormCategory(formId:number,formCatId: number ): Observable<number> {
  const options = {
    params: new HttpParams().set('formCatId', formCatId.toString()).set('formId', formId.toString())
  };
return this._http.get<number>(this.UpdateDigitalFormCategoryId, options).pipe(catchError(this.handleError));

}

public UpdateFECRFromType(formId:number,FECRInspectionType: number ): Observable<number> {
  const options = {
    params: new HttpParams().set('FECRInspectionType', FECRInspectionType.toString()).set('formId', formId.toString())
  };
return this._http.get<number>(this.UpdateFormFECRInspectionType, options).pipe(catchError(this.handleError));

}



// public DeleteSelectedQuestion(formId:number,QuestionId: number ): Observable<number> {
//   const options = {
//     params: new HttpParams().set('QuestionId', QuestionId.toString()).set('formId', formId.toString())
//   };
// return this._http.get<number>(this.DeleteFormQuestion, options).pipe(catchError(this.handleError));

// }

// public DeleteSelectedCategory(formId:number,CatId: number,ParentCatId:number ): Observable<number> {
//   const options = {
//     params: new HttpParams().set('CatId', CatId.toString()).set('formId', formId.toString()).set('ParentCatId', ParentCatId.toString())
//   };
// return this._http.get<number>(this.DeleteFormSection, options).pipe(catchError(this.handleError));

// }

public UpdateEmailOnComplete(formId: number ): Observable<number> {
  const options = {
    params: new HttpParams().set('formId', formId.toString())
  };
return this._http.get<number>(this.ToggleEmailOnCompleteOnDigitalForm, options).pipe(catchError(this.handleError));

}

public UpdateIsMagetic(QuestionId: number ): Observable<number> {
  const options = {
    params: new HttpParams().set('QuestionId', QuestionId.toString())
  };
return this._http.get<number>(this.ToggleUpdateIsMagetic, options).pipe(catchError(this.handleError));

}
public UpdateActivateLimits(QuestionId: number ): Observable<number> {
  const options = {
    params: new HttpParams().set('QuestionId', QuestionId.toString())
  };
return this._http.get<number>(this.ToggleUpdateIsActivateLimits, options).pipe(catchError(this.handleError));

}

public UpdateStartByInspectoor(formId: number ): Observable<number> {
  const options = {
    params: new HttpParams().set('formId', formId.toString())
  };
return this._http.get<number>(this.ToggleStartByInspectoreOnDigitalForm, options).pipe(catchError(this.handleError));

}

public UpdateStartBySupervisor(formId: number ): Observable<number> {
  const options = {
    params: new HttpParams().set('formId', formId.toString())
  };
return this._http.get<number>(this.ToggleStartBySupervisorOnDigitalForm, options).pipe(catchError(this.handleError));

}

public UpdateFECRForm(formId: number ): Observable<number> {
  const options = {
    params: new HttpParams().set('formId', formId.toString())
  };
return this._http.get<number>(this.ToggleFECRTypeDigitalForm, options).pipe(catchError(this.handleError));

}

public UpdateFormName(formId: number,formName:string ,isEdit:number): Observable<number> {
  const options = {
    params: new HttpParams().set('formId', formId.toString()).set('formName', formName).set('isEdit', isEdit.toString())
  };
return this._http.get<number>(this.UpdateDigitalFormName, options).pipe(catchError(this.handleError));

}
public getFormCategoryList(): Observable<GenericIdName[]> {
  return this._http.get<GenericIdName[]>(this.GetFormCategoryListInfo).pipe(catchError(this.handleError));
}

public getFECRInspectionTypes(): Observable<GenericIdName[]> {
  return this._http.get<GenericIdName[]>(this.GetFECRInspectionTypesInfo).pipe(catchError(this.handleError));
}
public GetDigitalFormDetails(formId: number): Observable<DigitalFormDataVM> {
  const options = {
    params: new HttpParams().set('formId', formId.toString())
  };
return this._http.get<DigitalFormDataVM>(this.GetDigitalFormInfo, options).pipe(catchError(this.handleError));

}

public GetDigitalFormHeaderFields(formId: number): Observable<FormHeaderVM[]> {
  const options = {
    params: new HttpParams().set('formId', formId.toString())
  };
return this._http.get<FormHeaderVM[]>(this.GetFormHeaderInfo, options).pipe(catchError(this.handleError));

}
public AddNewcategory(formId: number, CatName:string ): Observable<number> {
  const options = {
    params: new HttpParams().set('formId', formId.toString()).set('CatName', CatName)
  };
return this._http.get<number>(this.AddCategory, options).pipe(catchError(this.handleError));

}

public UpdateFormHeader(standardId: number, QuestionId:number, formId:number ): Observable<boolean> {
  const options = {
    params: new HttpParams().set('standardId', standardId.toString()).set('QuestionId', QuestionId.toString()).set('formId', formId.toString())
  };
return this._http.get<boolean>(this.UpdateFormHeaderInfo, options).pipe(catchError(this.handleError));

}

public EditcategoryOrSection(catId: number, CatName:string,isEdit:number ): Observable<number> {
  const options = {
    params: new HttpParams().set('catId', catId.toString()).set('CatName', CatName).set('isEdit', isEdit.toString())
  };
return this._http.get<number>(this.EditCategorySection, options).pipe(catchError(this.handleError));

}
public AddNewSection(formId: number, parentCatId:number,sectionName:string ): Observable<number> {
  const options = {
    params: new HttpParams().set('formId', formId.toString()).set('parentCatId', parentCatId.toString()).set('sectionName', sectionName)
  };
return this._http.get<number>(this.AddSection, options).pipe(catchError(this.handleError));

}


public GetQuestionDetails(QuestionId:number ): Observable<AddQuestionVM> {
  const options = {
    params: new HttpParams().set('QuestionId', QuestionId.toString())
  };
return this._http.get<AddQuestionVM>(this.GetQuestionInfo, options).pipe(catchError(this.handleError));

}
public AddNewQuestion(model: AddQuestionVM): Observable<boolean> {
  return this._http.post<boolean>(this.AddQuestion, model).pipe(catchError(this.handleError));
}

public EditQuestion(model: AddQuestionVM): Observable<boolean> {
  return this._http.post<boolean>(this.EditSelectedQuestion, model).pipe(catchError(this.handleError));
}
public TogglelFormQuestion(QuestionId:number ,status:boolean,isEdit:number): Observable<AddQuestionVM> {
  const options = {
    params: new HttpParams().set('QuestionId', QuestionId.toString()).set('status', status.toString()).set('isEdit', isEdit.toString())
  };
return this._http.get<AddQuestionVM>(this.ToggleDigitalFormQuestion, options).pipe(catchError(this.handleError));

}
public TogglelFormCategory(CategoryId:number ,status:boolean,isEdit:number): Observable<AddQuestionVM> {
  const options = {
    params: new HttpParams().set('CategoryId', CategoryId.toString()).set('status', status.toString()).set('isEdit', isEdit.toString())
  };
return this._http.get<AddQuestionVM>(this.ToggleDigitalForCategory, options).pipe(catchError(this.handleError));

}

public OrderUp_Q(FormId:number ,Order:number, sectionId:number)  {
  const options = {
    params: new HttpParams().set('FormId', FormId.toString()).set('Order', Order.toString()).set('sectionId', sectionId.toString())
  };
return this._http.get(this.OrderUpForQuestions, options).pipe(catchError(this.handleError));

}

public OrderDown_Q(FormId:number ,Order:number, sectionId:number)  {
  const options = {
    params: new HttpParams().set('FormId', FormId.toString()).set('Order', Order.toString()).set('sectionId', sectionId.toString())
  };
return this._http.get(this.OrderDownForQuestions, options).pipe(catchError(this.handleError));

}

public OrderUp_Section(FormId:number ,Order:number,ParentId:number)  {
  const options = {
    params: new HttpParams().set('FormId', FormId.toString()).set('Order', Order.toString()).set('ParentId', ParentId.toString())
  };
return this._http.get(this.OrderUpForSection, options).pipe(catchError(this.handleError));

}

public OrderDown_Section(FormId:number ,Order:number,ParentId:number)  {
  const options = {
    params: new HttpParams().set('FormId', FormId.toString()).set('Order', Order.toString()).set('ParentId', ParentId.toString())
  };
return this._http.get(this.OrderDownForSection, options).pipe(catchError(this.handleError));

}


public OrderUp_Categories(FormId:number ,Order:number)  {
  const options = {
    params: new HttpParams().set('FormId', FormId.toString()).set('Order', Order.toString())
  };
return this._http.get(this.OrderUpForCategories, options).pipe(catchError(this.handleError));

}

public OrderDown_Categories(FormId:number ,Order:number)  {
  const options = {
    params: new HttpParams().set('FormId', FormId.toString()).set('Order', Order.toString())
  };
return this._http.get(this.OrderDownForCategories, options).pipe(catchError(this.handleError));

}


// public LoadImplmentTypes(): Observable<GenericIdName[]> {
// return this._http.get<GenericIdName[]>(this.GetAllImplementTypes).pipe(catchError(this.handleError));

// }

public LoadImplmentTypes(params:ImplementLoadVM): Observable<GenericIdName[]> {
  return this._http.post<GenericIdName[]>(this.GetAllImplementTypes, params).pipe(catchError(this.handleError));
}


public GetFormLinkedTemplateType(FormId:number ) : Observable<GenericIdName[]> {
  const options = {
    params: new HttpParams().set('FormId', FormId.toString())
  };
return this._http.get<GenericIdName[]>(this.GetFormLinkedImplementTemplatesTypes, options).pipe(catchError(this.handleError));

}

public LoadImplmentTemplates(params:ImplementLoadVM): Observable<GenericIdName[]> {
  return this._http.post<GenericIdName[]>(this.GetAllImplementTemplates, params).pipe(catchError(this.handleError));
}


public GetComponentTypes(implementTypeId:number, FormId:number ) : Observable<ComponentTypeList[]> {
  const options = {
    params: new HttpParams().set('implementTypeId', implementTypeId.toString()).set('FormId', FormId.toString())
  };
return this._http.get<ComponentTypeList[]>(this.GetComponentTypesByImplementTypeId, options).pipe(catchError(this.handleError));

}


// public GetCompoentsAvailable(compoenetTypeIds: number[], FormId:number): Observable<ComponentTypeList[]> {
//   let params: URLSearchParams = new URLSearchParams();
//   params.set('FormId', FormId.toString());
//   return this._http.post<ComponentTypeList[]>(this.GetComponentByComponentTypeIds, compoenetTypeIds).pipe(catchError(this.handleError));
// }

public GetCompoentsAvailable(compoenetTypeIds: CompListVM): Observable<ComponentTypeList[]> {
  return this._http.post<ComponentTypeList[]>(this.GetComponentByComponentTypeIds, compoenetTypeIds).pipe(catchError(this.handleError));
}
public GetjobsitesAvailable(params: JobsiteSelectionFilter): Observable<GenericIdName_[]> {
  return this._http.post<GenericIdName_[]>(this.GET_JOBSITE_FILTER, params).pipe(catchError(this.handleError));
}

// public GetjobsitesAvailable_(params: JobsiteSelectionFilter): Observable<GenericIdName_[]> {
//   return this._http.post(this.GET_JOBSITE_FILTER, params).share().map(
//       (response: Response) => <GenericIdName_[]>response.json()).catch(this.handleError);
// }
  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
}

  public getUnitMeasures(unitTypeId: number) : Observable<UnitMeasureDto> {
    const options = {
    params: new HttpParams().set('unitTypeId', unitTypeId)
  };
    return this._http.get<UnitMeasureDto>(this.GET_UNIT_MEASURE, options).pipe(catchError(this.handleError));
  }
 
  public getFilteredFamilyDetails(Customer:string, Jobsite:string) : Observable<FamilyDto> {
    const options = {
      params: new HttpParams().set('Customer', Customer.toString()).set('Jobsite', Jobsite.toString())
    };
    return this._http.get<FamilyDto>(this.GET_FILTERED_FAMILY, options).pipe(catchError(this.handleError));
  }
}
